import type { SpectralWorkspaceSnapshot } from '../types';

const storageKey = (analysisId: string) =>
  `spectral-workspace-snapshot:${analysisId}`;

export const readCachedAnalysisSnapshot = (
  analysisId: string
): SpectralWorkspaceSnapshot | null => {
  if (typeof sessionStorage === 'undefined') return null;

  try {
    const raw = sessionStorage.getItem(storageKey(analysisId));
    if (!raw) return null;

    return JSON.parse(raw) as SpectralWorkspaceSnapshot;
  } catch {
    return null;
  }
};

export const writeCachedAnalysisSnapshot = (
  analysisId: string,
  snapshot: SpectralWorkspaceSnapshot
) => {
  if (typeof sessionStorage === 'undefined') return;

  try {
    sessionStorage.setItem(storageKey(analysisId), JSON.stringify(snapshot));
  } catch {
    // Ignore quota errors.
  }
};
